module.exports = __webpack_public_path__ + "static/media/5.81619741.jpg";